//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import Keyboard from './carNo-input-keyboard'
export default {
    props: {
        mode: String,
        value: String
    },
    components: {
        Keyboard
    },
    data () {
        return {
            carnoArr: ['', '', '', '', '', '', '', ''],
            current: 0,
            visible: false
        }
    },
    watch: {
        mode(val) {
            let array = [];
            let num = val === 'plate' ? 8 : 11;
            for (let i = 0; i < num; i++) {
                array.push('');
            }
            this.carnoArr = array;
        },
        carnoArr: {
            handler () {
                const list = this.carnoArr.filter(item => item)
                this.$emit('input', list.join(''))
            },
            deep: true
        },
        // value() {
        //     let num = this.mode === 'plate' ? 8 : 11;
        //     let array = this.value.split('');
        //     num = num - array.length;
        //     for (let i = 0; i < num; i++) {
        //         array.push('');
        //     }
        //     this.carnoArr = array;
        // }
    },
    methods: {
        onInputClick (index) {
            if (!this.visible) {
                this.visible = true
            }
            this.current = index
        },
        keyboardChange (key) {
            // const { key, type } = params
            if (key === 'delete') {
                Vue.set(this.carnoArr, this.current, '')
                if (this.current > 0) {
                    this.current--
                }
            // } else if (this.current === 1 && type === 'number') {
            } else {
                Vue.set(this.carnoArr, this.current, key)
                if (this.current < this.carnoArr.length - 1) {
                    this.current++
                }
            }
        },
        keyboardClear () {
            this.carnoArr = ['', '', '', '', '', '', '', '']
            this.current = 0
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/carNo-input/index.vue